import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exam-cell',
  templateUrl: './exam-cell.component.html',
  styleUrls: ['./exam-cell.component.scss']
})
export class ExamCellComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
